import { Injectable } from '@angular/core';

@Injectable()
export class DocumentRef {
    getNativeDocument(): HTMLDocument { return document; }
}
